// dniValidationStore.ts
import { create } from "zustand";

type DniValidationState = {
  isValid: boolean | null;
  error: string | null;
  setValidation: (state: { isValid: boolean; error: string | null }) => void;
  reset: () => void;
};

export const useDniValidationStore = create<DniValidationState>((set) => ({
  isValid: true,
  error: null,
  setValidation: (state) => set(state),
  reset: () => set({ isValid: null, error: null }),
}));
